import React, { useEffect, useState } from "react";
import { envConfig, unifiedEnvConfig } from "../../constants/api-endpoint";
import { httpGet, httpPut } from "../../utility/requestHelper";
import { useSelector, useDispatch } from "react-redux";
import { HTTP_CODES, CONSTANTS,COOKIE } from "../../constants/app-constant";
import Loader from "../Shared/Loader";
import { getData } from "../../actions/entity-action";
import ReactGA from "react-ga4";
import { getCookie } from "../../utility/cookieProvider";
import {GACODE} from "../../constants/app-constant";

export const Configuration = () => {
  ReactGA.initialize(GACODE);

  const { DEFAULT_VALUE } = CONSTANTS;
  const [limitData, setLimitData] = useState([]);
  const [facebook, instagram, twitter, youtube, blog, forum, linkedin, pinterest] =
    limitData;
  const [usedData, setUsedData] = useState([]);
  const [facebookData, setFacebookData] = useState("");
  const [instagramData, setInstagramData] = useState("");
  const [twitterData, setTwitterData] = useState("");
  const [youtubeData, setYoutubeData] = useState("");
  const [blogData, setBlogData] = useState("");
  const [forumData, setForumData] = useState("");
  const [pinterestData, setPinterestData] = useState("");
  const [linkedInData, setLinkedInData] = useState("");
  const [totalPost, setTotalPost] = useState("");
  const [currentMonthPost, setCurrentMonthPost] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [responseMsg, setresponseMsg] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [loader, setLoader] = useState(false);
  const [totalUpdatedpost, setTotalUpdatedpost] = useState("");
  const dispatch = useDispatch();

  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};
  const IsSocialFlag =
    useSelector(
      (state) =>
        state.entityAndKeyWordsReducer &&
        state.entityAndKeyWordsReducer.configuration
    ) || {};
  const { isLoading } = IsSocialFlag;
  const { metadata, limit_metadata } = IsSocialFlag.configuration;
  // const getData = () => {
  //   setLoader(true);
  //   httpGet(`${unifiedEnvConfig.LIMIT}/${selectedClient.id}`).then((res) => {
  //     if (res) {
  //       setLoader(false);
  //       const { limit_metadata, metadata } = res.data.data;
  //       if (metadata) {
  //         const { total_post, used_post } = res.data.data.metadata.services[0];
  //         setTotalPost(total_post ? total_post : DEFAULT_VALUE);
  //         setCurrentMonthPost(used_post);
  //       }
  //       if (limit_metadata) {
  //         setLimitData(
  //           limit_metadata.map(({ limit }) => {
  //             return limit;
  //           })
  //         );
  //         setUsedData(
  //           limit_metadata.map(({ used }) => {
  //             return used;
  //           })
  //         );
  //       }
  //     }
  //   });
  // };
  useEffect(() => {
    if (selectedClient && selectedClient.id) {
      dispatch(getData(selectedClient.id));
    }
  }, [selectedClient]);

  const concept_uid = getCookie(COOKIE.CONCEPT_USER_ID);  
  if(selectedClient.id != undefined && selectedClient.id != '' && selectedClient.id != null){
    ReactGA.set({ userId: selectedClient.id+".0."+concept_uid });
    ReactGA.set({ 'user_id': selectedClient.id+".0."+concept_uid });
  }

  let locationHrefNew = window.location.href;
  if(selectedClient.id != undefined && selectedClient.id != '' && selectedClient.id != null){
    ReactGA.event({
      category: "Profile Configuration",
      action: "Profile Configuration - " +selectedClient.id+".0."+concept_uid,
      label: locationHrefNew, // optional
      //value: selectedClient.id+"000"+concept_uid, // optional, must be a number
    });
  }

  useEffect(() => {
    if (metadata) {
      const { total_post, used_post } = metadata.services[0];
      setTotalPost(total_post ? total_post : DEFAULT_VALUE);
      setCurrentMonthPost(used_post);
    }
    if (limit_metadata) {
      setLimitData(
        limit_metadata.map(({ limit }) => {
          return limit;
        })
      );
      setUsedData(
        limit_metadata.map(({ used }) => {
          return used;
        })
      );
    }
  }, [IsSocialFlag]);

  const resetAll = () => {
    setConfirm(false);
    setFacebookData("");
    setInstagramData("");
    setYoutubeData("");
    setTwitterData("");
    setBlogData("");
    setForumData("");
    setPinterestData("");
    setLinkedInData("");
  };

  const platformArr = [
    {
      platform: "Facebook",
      limit: facebookData,
      used: usedData[0] || DEFAULT_VALUE,
      placeholder: facebook || DEFAULT_VALUE,
    },
    {
      platform: "Instagram",
      limit: instagramData,
      used: usedData[1] || DEFAULT_VALUE,
      placeholder: instagram || DEFAULT_VALUE,
    },
    {
      platform: "X",
      limit: twitterData,
      used: usedData[2] || DEFAULT_VALUE,
      placeholder: twitter || DEFAULT_VALUE,
    },
    {
      platform: "YouTube",
      limit: youtubeData,
      used: usedData[3] || DEFAULT_VALUE,
      placeholder: youtube || DEFAULT_VALUE,
    },
    {
      platform: "Blogs",
      limit: blogData,
      used: usedData[4] || DEFAULT_VALUE,
      placeholder: blog || DEFAULT_VALUE,
    },
    {
      platform: "Forum",
      limit: forumData,
      used: usedData[5] || DEFAULT_VALUE,
      placeholder: forum || DEFAULT_VALUE,
    },
    {
      platform: "LinkedIn",
      limit: linkedInData,
      used: usedData[6] || DEFAULT_VALUE,
      placeholder: linkedin || DEFAULT_VALUE,
    },
  ];


  useEffect(() => {
    setTotalUpdatedpost(
      (facebookData ? Number(facebookData) : Number(facebook)) +
        (instagramData ? Number(instagramData) : Number(instagram)) +
        (twitterData ? Number(twitterData) : Number(twitter)) +
        (youtubeData ? Number(youtubeData) : Number(youtube)) +
        (blogData ? Number(blogData) : Number(blog)) +
        (forumData ? Number(forumData) : Number(forum)) +
        (pinterestData ? Number(pinterestData) : Number(pinterest)) +
        (linkedInData ? Number(linkedInData) : Number(linkedin))
    );
    setDisabled(totalPost - currentMonthPost < totalUpdatedpost);
    setErrorMsg(
      totalPost - currentMonthPost < totalUpdatedpost
        ? "You have exceeded the limit"
        : ""
    );
  }, [platformArr]);

  const allowNumericInput = (e) => {
    if (!(e.key >= 0 && e.key <= 9)) {
      e.preventDefault();
      e.stopPropagation();
    }
  };
  const onchangeHandler = (e, el) => {
    const data = e.target.value && e.target.value.trim();
    if (el === "Facebook") {
      setFacebookData(data);
    }
    if (el === "Instagram") {
      setInstagramData(data);
    }
    if (el === "X") {
      setTwitterData(data);
    }
    if (el === "YouTube") {
      setYoutubeData(data);
    }
    if (el === "Blogs") {
      setBlogData(data);
    }
    if (el === "Forum") {
      setForumData(data);
    }
    if (el === "LinkedIn") {
      setLinkedInData(data);
    }
    if (el === "Pinterest") {
      setPinterestData(data);
    }
    
  };

  const updateHandler = () => {
    setLoader(true);
    const platform = {
      limit_metadata: [
        {
          platform: 1,
          limit: Number(
            facebookData ? facebookData : facebook ? facebook : DEFAULT_VALUE
          ),
          used: Number(usedData[0] || DEFAULT_VALUE),
        },
        {
          platform: 2,
          limit: Number(
            instagramData
              ? instagramData
              : instagram
              ? instagram
              : DEFAULT_VALUE
          ),
          used: Number(usedData[1] || DEFAULT_VALUE),
        },
        {
          platform: 3,
          limit: Number(
            twitterData ? twitterData : twitter ? twitter : DEFAULT_VALUE
          ),
          used: Number(usedData[2] || DEFAULT_VALUE),
        },
        {
          platform: 4,
          limit: Number(
            youtubeData ? youtubeData : youtube ? youtube : DEFAULT_VALUE
          ),
          used: Number(usedData[3] || DEFAULT_VALUE),
        },
        {
          platform: 5,
          limit: Number(blogData ? blogData : blog ? blog : DEFAULT_VALUE),
          used: Number(usedData[4] || DEFAULT_VALUE),
        },
        {
          platform: 6,
          limit: Number(forumData ? forumData : forum ? forum : DEFAULT_VALUE),
          used: Number(usedData[5] || DEFAULT_VALUE),
        },
        {
          platform: 10,
          limit: Number(linkedInData ? linkedInData : linkedin ? linkedin : DEFAULT_VALUE),
          used: Number(usedData[6] || DEFAULT_VALUE),
        },
        // {
        //   platform: 7,
        //   limit: Number(
        //     pinterestData
        //       ? pinterestData
        //       : pinterest
        //       ? pinterest
        //       : DEFAULT_VALUE
        //   ),
        //   used: Number(usedData[6] || DEFAULT_VALUE),
        // },
      ],
      total_post: Number(totalPost),
      used_post: Number(currentMonthPost || DEFAULT_VALUE),
    };

    httpPut(
      `${unifiedEnvConfig.UPDATE_LIMIT}?client_id=${selectedClient.id}`,
      platform
    ).then((res) => {
      const { status , message } = res.data;
      console.log(res.data,message)
      if (status === HTTP_CODES.SUCCESS && !message) {
        setLoader(false);
        dispatch(getData(selectedClient.id));
        resetAll();
      }
      else{
        setLoader(false);
        dispatch(getData(selectedClient.id));
        resetAll();
        setresponseMsg(message)
      }
    });
  };

  return (
    <div>
      {(isLoading || loader) && <Loader />}
      {(!isLoading || !loader) && !totalPost && (
        <div className="personalDetailsWrap">
          Please contact admin for post limit
        </div>
      )}
      {(!isLoading || !loader) && !confirm && totalPost && (
        <div>
          <div className="personalDetailsWrap">
            {responseMsg && <p className="text-center redText">{responseMsg}</p>}
            <p>Total Post Limit : {totalPost}</p>
            <p>Actual for current month : {currentMonthPost}</p>
            <h4>Breakdown</h4>
            <div className="configview">
              <table>
                <thead className="text-center">
                  <tr>
                    <th>Platform</th>
                    <th>Limit</th>
                    <th>Actual for current month</th>
                  </tr>
                </thead>
                {platformArr.map(({ platform, limit, used, placeholder }) => {
                  return (
                    <tbody className="text-center">
                      <tr key={platform}>
                        <td>{platform}</td>
                        <td>
                          <input
                            type="text"
                            value={limit}
                            onChange={(e) => onchangeHandler(e, platform)}
                            placeholder={placeholder}
                            onKeyPress={allowNumericInput}
                          />
                        </td>

                        <td>
                          <p>{used}</p>
                        </td>
                      </tr>
                      {used > (Number(limit) || placeholder) && (
                        <p className="text-center">
                          Limit should not be less than current used post
                        </p>
                      )}
                    </tbody>
                  );
                })}
              </table>
            </div>
          </div>
          <div className="fulwidth">
            <button
              className="btn btnBlue addTopicBtn"
              onClick={() => setConfirm(true)}
              disabled={disabled}
            >
              Update
            </button>
          </div>
          {errorMsg && <>{errorMsg}</>}
        </div>
      )}
      {!loader && confirm && (
        <div className="personalDetailsWrap">
          <div className="fulwidth mt0">
            <p>Do you want to update?</p>
            <button
              className="border-btn btn primary-btn"
              onClick={() => {
                resetAll();
              }}
            >
              No
            </button>
            <button
              onClick={updateHandler}
              className="border-btn btn primary-btn"
            >
              Yes
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
